(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StepHeader", [], factory);
	else if(typeof exports === 'object')
		exports["StepHeader"] = factory();
	else
		root["StepHeader"] = factory();
})(this, function() {
return 